import { render, staticRenderFns } from "./leftcard2.vue?vue&type=template&id=ee67742c&scoped=true"
import script from "./leftcard2.vue?vue&type=script&lang=js"
export * from "./leftcard2.vue?vue&type=script&lang=js"
import style0 from "./leftcard2.vue?vue&type=style&index=0&id=ee67742c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee67742c",
  null
  
)

export default component.exports